import { useMatches } from 'react-router';
import { type RouteHandle } from '../router/types';

export const useCurrentRoute = () => {
  const matches = useMatches();
  const currentMatch = matches[matches.length - 1];

  const { pathname, handle = {} } = currentMatch;
  const { title, icon } = handle as RouteHandle;

  return { pathname, title, icon };
};
